import { ChainType } from '@repo/types-client';

const socketAcknowledgement = 'ok';
const swapEnvironmentHeader = 'environment-id';
const swapInvalidOriginError = 'origin is not allowed';
const swapAssetLimit = 25;
const chatCharacterLimit = 400;
const defaultSwapDataProviderContext: ChainType = 'base';

export {
  swapAssetLimit,
  swapInvalidOriginError,
  chatCharacterLimit,
  swapEnvironmentHeader,
  socketAcknowledgement,
  defaultSwapDataProviderContext,
};
